import React from 'react';
import { VaultKeTheme } from '../../utils/theme';

const Pricing: React.FC = () => {
  const styles: { [key: string]: React.CSSProperties } = {
    page: {
      minHeight: '100vh',
      backgroundColor: VaultKeTheme.colors.background,
      color: VaultKeTheme.colors.text,
    },
    main: {
      paddingTop: '80px',
      paddingBottom: VaultKeTheme.spacing.xxl,
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: `0 ${VaultKeTheme.spacing.xl}`,
    },
    header: {
      textAlign: 'center',
      marginBottom: VaultKeTheme.spacing.xxl,
    },
    title: {
      ...VaultKeTheme.typography.h1,
      color: VaultKeTheme.colors.text,
      marginBottom: VaultKeTheme.spacing.lg,
    },
    subtitle: {
      ...VaultKeTheme.typography.body1,
      color: VaultKeTheme.colors.textSecondary,
      maxWidth: '600px',
      margin: '0 auto',
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: VaultKeTheme.spacing.xl,
      marginTop: VaultKeTheme.spacing.xxl,
    },
    plan: {
      ...VaultKeTheme.components.card,
      textAlign: 'center',
      position: 'relative',
    },
    popular: {
      position: 'absolute',
      top: '-10px',
      left: '50%',
      transform: 'translateX(-50%)',
      background: VaultKeTheme.colors.primary,
      color: VaultKeTheme.colors.background,
      padding: '4px 12px',
      borderRadius: '12px',
      fontSize: '0.8rem',
      fontWeight: 'bold',
    },
    planTitle: {
      ...VaultKeTheme.typography.h3,
      color: VaultKeTheme.colors.text,
      marginBottom: VaultKeTheme.spacing.md,
    },
    price: {
      ...VaultKeTheme.typography.h1,
      color: VaultKeTheme.colors.primary,
      marginBottom: VaultKeTheme.spacing.md,
    },
    period: {
      ...VaultKeTheme.typography.body2,
      color: VaultKeTheme.colors.textSecondary,
      marginBottom: VaultKeTheme.spacing.lg,
    },
    features: {
      listStyle: 'none',
      padding: 0,
      marginBottom: VaultKeTheme.spacing.xl,
    },
    feature: {
      ...VaultKeTheme.typography.body2,
      color: VaultKeTheme.colors.textSecondary,
      marginBottom: VaultKeTheme.spacing.sm,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: VaultKeTheme.spacing.sm,
    },
    button: {
      ...VaultKeTheme.components.button.primary,
      width: '100%',
    },
  };

  const plans = [
    {
      name: 'Starter',
      price: 'Free',
      period: 'Forever',
      features: [
        'Up to 25 members',
        'Basic financial tracking',
        'Mobile app access',
        'Community support',
      ],
      buttonText: 'Get Started',
    },
    {
      name: 'Professional',
      price: 'KSh 2,500',
      period: '/month',
      popular: true,
      features: [
        'Up to 100 members',
        'Advanced analytics',
        'Priority support',
        'Custom integrations',
        'Meeting management',
      ],
      buttonText: 'Start Free Trial',
    },
    {
      name: 'Enterprise',
      price: 'Custom',
      period: 'Pricing',
      features: [
        'Unlimited members',
        'White-label solution',
        'Dedicated support',
        'API access',
        'Advanced security',
      ],
      buttonText: 'Contact Sales',
    },
  ];

  return (
    <main style={styles.main}>
      <div style={styles.container}>
        <div style={styles.header}>
          <h1 style={styles.title}>Simple, Transparent Pricing</h1>
          <p style={styles.subtitle}>
            Choose the perfect plan for your chama. All plans include our core features
            with different limits and support levels.
          </p>
        </div>

        <div style={styles.grid}>
          {plans.map((plan, index) => (
            <div key={index} style={styles.plan}>
              {plan.popular && <div style={styles.popular}>Most Popular</div>}
              <h3 style={styles.planTitle}>{plan.name}</h3>
              <div style={styles.price}>{plan.price}</div>
              <div style={styles.period}>{plan.period}</div>
              <ul style={styles.features}>
                {plan.features.map((feature, featureIndex) => (
                  <li key={featureIndex} style={styles.feature}>
                    <span>✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
              <button style={styles.button}>{plan.buttonText}</button>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
};

export default Pricing;